import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from "vue";
import { Document } from "@/types";
import IconButton from "@/components/ds/icon-button/IconButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentOpen',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const open = () => {
    const fileLocation =
        "https://drive.google.com/file/d/" +
        props.document?.google_drive_id +
        "/view?usp=sharing";
    window.open(fileLocation);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IconButton, {
    onClick: open,
    "icon-id": "arrow-right"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode(" Open PDF vanaf Google Drive ")
    ])),
    _: 1
  }))
}
}

})